import { Image, Target, Heart, FileText, Layout, Mail, Phone } from 'lucide-react';

export const SECTION_TYPES = [
  { id: 'hero', name: 'Hero Banner', icon: Image, description: 'Full-width hero with image background' },
  { id: 'stats', name: 'Stats Bar', icon: Target, description: 'Progress and milestone statistics' },
  { id: 'mission', name: 'Mission Statement', icon: Heart, description: 'Mission text with images' },
  { id: 'milestones', name: 'Milestones', icon: Target, description: 'Project milestone cards' },
  { id: 'gallery', name: 'Photo Gallery', icon: Image, description: 'Image gallery grid' },
  { id: 'updates', name: 'Latest Update', icon: FileText, description: 'Recent progress update' },
  { id: 'cta', name: 'Call to Action', icon: Heart, description: 'Donation CTA section' },
  { id: 'quicklinks', name: 'Quick Links', icon: Layout, description: 'Navigation cards grid' },
  { id: 'fundraising', name: 'Fundraising Progress', icon: Target, description: 'Goal progress bar' },
  { id: 'newsletter', name: 'Newsletter Signup', icon: Mail, description: 'Email subscription form' },
  { id: 'contact', name: 'Contact Info', icon: Phone, description: 'Contact details section' },
];

export const API_URL = process.env.REACT_APP_BACKEND_URL;
